module.exports = __webpack_public_path__ + "img/galeria-pacs-grafico.afae2322.png";